/* eslint-disable import/no-anonymous-default-export */

import {
    LOADING,
    LOADING_OFF,
    ERROR,
    LOG_IN,
    LOGOUT
} from '../actions/UserAction'

export const initialState = {
    // gmail: '',
    // fmail: '',
    // click: false,
    // name: '',
    // token: '',
    userInfo: '',
    errorMessage: '',
    loading: false,

}

export default (state = initialState, action) => {
    switch(action.type){
        case LOADING:
            return {...state, loading: true, errorMessage: ''}
        case LOADING_OFF:
            return {...state, loading: false}
        case ERROR:
            return {...state, errorMessage: action.payload}
        case LOG_IN:
            return {...state, userInfo: action.payload}
        case LOGOUT:
            return {...state, userInfo: ''}
        default:
            return state
    }
}